import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PDPState, VehicleState } from '@/global/models/IPDPState';
import { RootState } from '@/store/redux';

export const initialState: PDPState = {
  vehicle: {
    vehicleId: '',
    financing: {
      type: '',
      downPayment: 0,
      duration: 0,
      mileage: 0,
      finalInstallment: 0,
      monthlyInstallment: 0,
    },
    dealer: null,
    price: 0,
    persistentState: false,
  },
};

const SLICE_NAME = 'PDP';

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setVehicle(state, action: PayloadAction<VehicleState>) {
      state.vehicle = { ...state.vehicle, ...action.payload };
    },
    setPersistVehicleState(
      state,
      action: PayloadAction<{ persistentState: boolean }>
    ) {
      state.vehicle.persistentState = action.payload.persistentState;
    },
    reset() {
      return initialState;
    },
  },
});

export const { setVehicle, setPersistVehicleState, reset } = slice.actions;

export const getPDPState = (state: RootState) => state.pages.pdp;

export default slice.reducer;
